var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 339,
    viewBox: "0 0 400 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_2172)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.528 209.066L111.106 206.579C105.134 202.572 99.5254 198.152 94.4352 193.509C67.9107 169.323 51.6374 135.197 44.6763 89.1709L41.7402 89.5329C48.8304 136.305 65.4142 171.026 92.5043 195.716C97.701 200.471 103.449 204.946 109.552 209.05L109.528 209.066Z",
    fill: "#83E4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.253 318.853C290.49 315.113 288.562 311.442 286.616 307.962C282.856 301.316 278.709 295.097 274.304 289.512C267.124 280.4 259.059 272.682 250.266 266.548C247.42 264.545 244.458 262.688 241.439 261.013C225.322 252.024 206.639 245.936 186.847 239.476L186.058 239.223C175.719 235.843 163.967 231.996 152.53 227.552L151.534 230.351C163.029 234.831 174.822 238.688 185.202 242.077L185.991 242.33C205.618 248.752 224.178 254.81 240.024 263.647C242.946 265.278 245.834 267.073 248.606 269.015C257.112 274.972 264.979 282.491 271.971 291.363C276.27 296.836 280.319 302.901 284.022 309.404C285.959 312.816 287.814 316.426 289.569 320.1L292.229 318.869L292.253 318.853Z",
    fill: "#83E4FE"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M250.626 336.063C218.914 328.492 198.437 296.448 204.889 264.49C211.34 232.532 242.277 212.762 273.989 220.333C305.7 227.904 326.177 259.948 319.726 291.906C313.274 323.864 282.337 343.634 250.626 336.063Z",
    fill: "url(#paint0_radial_1064_2172)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M250.626 336.063C218.914 328.492 198.437 296.448 204.889 264.49C211.34 232.532 242.277 212.762 273.989 220.333C305.7 227.904 326.177 259.948 319.726 291.906C313.274 323.864 282.337 343.634 250.626 336.063Z",
    fill: "url(#paint1_radial_1064_2172)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M172.647 259.581C155.886 270.292 133.304 264.901 122.209 247.539C111.115 230.178 115.709 207.42 132.471 196.709C149.232 185.998 171.814 191.389 182.909 208.75C194.003 226.112 189.409 248.869 172.647 259.581Z",
    fill: "url(#paint2_radial_1064_2172)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M172.647 259.581C155.886 270.292 133.304 264.901 122.209 247.539C111.115 230.178 115.709 207.42 132.471 196.709C149.232 185.998 171.814 191.389 182.909 208.75C194.003 226.112 189.409 248.869 172.647 259.581Z",
    fill: "url(#paint3_radial_1064_2172)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M106.205 215.514C89.4433 226.225 66.8614 220.834 55.7669 203.473C44.6723 186.111 49.2665 163.354 66.0282 152.642C82.7899 141.931 105.372 147.322 116.466 164.684C127.561 182.045 122.967 204.803 106.205 215.514Z",
    fill: "url(#paint4_radial_1064_2172)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M106.205 215.514C89.4433 226.225 66.8614 220.834 55.7669 203.473C44.6723 186.111 49.2665 163.354 66.0282 152.642C82.7899 141.931 105.372 147.322 116.466 164.684C127.561 182.045 122.967 204.803 106.205 215.514Z",
    fill: "url(#paint5_radial_1064_2172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.304 278.194) rotate(147.42) scale(57.9856 60.0606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.304 278.194) rotate(147.42) scale(57.9856 60.0606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.559 228.145) rotate(147.42) scale(36.0173 37.3063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.559 228.145) rotate(147.42) scale(36.0173 37.3063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.1166 184.078) rotate(147.42) scale(36.0173 37.3063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1064_2172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.1166 184.078) rotate(147.42) scale(36.0173 37.3063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#508B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3A6565",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#284545",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#192C2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1818",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#060A0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_2172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 339,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line1.2f36a441b2568daf92ddaae9bc0b6624.svg";
export { ForwardRef as ReactComponent };